const FormConfig = module.exports = function formConfig(props = {}) {

    const {
        defaultValues,
        formId,
        onSubmit,
        schema
    } = props;

    return {
        onSubmit,
        defaults: defaultValues,
        fields: FormConfig.buildFields(),
        formId,
        schema,
        formOptions: {
            criteriaMode: 'all',
            mode: 'onBlur',
            reValidateMode: 'onBlur'
        }
    };
};

FormConfig.buildFormConfig = FormConfig;

FormConfig.buildFields = function buildFields() {

    return internals.buildFields();
};

FormConfig.buildSubmitPayload = function buildSubmitPayload(data = {}) {

    return data;
};

const internals = {};

internals.buildFields = () => ([
    {
        name: 'newPassword',
        type: 'TextField'
    },
    {
        name: 'confirmNewPassword',
        type: 'TextField'
    },
    {
        name: 'currentPassword',
        type: 'TextField'
    },
    {
        name: 'agreeToTerms',
        type: 'CheckboxField'
    },
    {
        name: 'logoutOtherDevices',
        type: 'CheckboxField'
    }
]);

FormConfig.internals = internals;
